import React from 'react';

function CommonAction({ dataIndex, editingInput, deleteItem, dppAddEditAccess, isProductArchived }) {
  return (
    dppAddEditAccess && (
      <div className="dpp-action-btns">
        <button
          aria-label="Edit"
          type="button"
          className="btn btn-border ml-auto py-0 px-1"
          onClick={() => editingInput(dataIndex)}
          disabled={isProductArchived}
        >
          <span className="icon-Edit-1 f-20" />
        </button>
        <button
          aria-label="Delete"
          type="button"
          className="btn btn-border ml-auto py-0 px-1"
          onClick={() => deleteItem(dataIndex)}
          disabled={isProductArchived}
        >
          <span className="icon-Delete f-20" />
        </button>
      </div>
    )
  );
}
export default CommonAction;
